export const CUSTOM_TARGET_LOCALIZATION_SCOPE = 'common-custom-target';
export const CUSTOM_TARGET_API_BASE_URL = '/api/targeting';
